import { MainMenu } from '@/components/MainMenu';
import { SidebarTrigger } from '@/components/ui/sidebar';

import { useIsMobile } from '@/hooks';

import { SidebarMenuProps } from '@/types';

import { ClientQuickSearchForm } from './ClientQuickSearchForm';
import { LocaleSwitcher } from './LocaleSwitcher';
import { LocationSwitcher } from './LocationSwitcher';
import { Logo } from './Logo';
import { ThemeToggle } from './ThemeToggle';
import { UiVersionToggle } from './UiVersionToggle';

export const Header = (props: SidebarMenuProps) => {
  const {
    location_props,
    user_name,
    company_id,
    sections,
    is_location_switcher_visible,
    is_system_owner,
  } = props;
  const isMobile = useIsMobile();

  return (
    <header className="dark bg-header text-foreground border-header-border sticky top-0 z-50 flex h-(--header-height) w-full items-center border-b px-2">
      <div className="flex items-center justify-start gap-2">
        <Logo className="h-8 w-auto shrink-0" />
        {isMobile && <SidebarTrigger />}
        <MainMenu sections={sections} />
        <ClientQuickSearchForm
          companyId={company_id}
          className={isMobile ? 'flex-1' : undefined}
        />
      </div>
      <div className="ml-auto flex items-center gap-3">
        <span className="text-foreground max-w-35 shrink-0 truncate text-sm font-medium">
          {user_name}
        </span>
        {!isMobile && is_location_switcher_visible && (
          <LocationSwitcher {...location_props} />
        )}
        {is_system_owner && <UiVersionToggle companyId={company_id} />}
        <ThemeToggle />
        {!isMobile && (
          <>
            <LocaleSwitcher url={props.change_languages_url} />
          </>
        )}
      </div>
    </header>
  );
};
